import Banner from "./Banner";  
import { Link } from "react-router-dom";
import Prezentacja_Wlaczanie from "./files/Włączanie i różnorodność w programie Erasmus+.pdf"
import Prezentacja_Srodowisko from "./files/ERASMUSDAYS_ŚRODOWISKO I WALKA ZE ZMIANAMI KLIMATU_.pdf"

let Links = () => {
    return(
        <div id = "textContainer">
            <h1>Linki</h1>
            <hr />
            <Banner />
            <hr /><br />

            <h2><strong>Upowszechnianie</strong></h2>
            <ul>
                <li><a href = "https://www.youtube.com/watch?v=29F14dAtCd0" target="_blank">Film z wyjazdu</a></li>
                <li><a href = "https://drive.google.com/file/d/1nKPmAHOm6HWpJxqmwJDwrMKFjZ9Me5lj/view" target = "_blank">Prezentacja zdjęć z wyjazdu</a></li>
                <li><a href = "https://drive.google.com/file/d/1cuvm-evSvIYa6k8Mw8X_jaWCtZatLgl6/view?usp=drive_link" target="_blank">Prezentacja z wyjazdu do Malagi</a></li>
                <li><Link to="/upowszechnianie/galeria">Zdjęcia ze spotkania podsumowującego</Link></li>
                
            </ul>
            

            <br />

            <h2><strong>Erasmus Days 2025</strong></h2>
            <ul>
                <li><a href = {Prezentacja_Wlaczanie} target = "_blank">Włączanie i różnorodność w programie Erasmus+</a></li>
                <li><a href = {Prezentacja_Srodowisko} target = "_blank">Środowisko i walka ze zmianą klimatu</a></li>
                <li>Relacje: <a href = "https://www.facebook.com/share/r/1EvcEecCk9/" target="_blank">Dzień 1</a>, <a href = "https://www.facebook.com/share/r/16ojoxTh7Y/" target="_blank">Dzień 2</a>, <a href = "https://www.facebook.com/share/r/1Gh4yhY31Q/" target="_blank">Dzień 3</a></li>
                <li><a href = "https://drive.google.com/file/d/1AfysWbds63llPfu4xwC6n1YiaM2D-PrV/view?usp=drive_link" target = "_blank">Jingiel reklamowy</a></li>
                <li><Link to="/erasmusdays/galeria">Zdjęcia</Link></li>
            </ul>
            
            <br />

            <h2><strong>O stażu w mediach</strong></h2>
            <ul>
                <li><a href = "https://www.tvswietokrzyska.pl/artykul/71190,dni-pelne-inspiracji-i-europejskiej-wspolpracy-erasmus-days-2025-w-zespole-szkol-informatycznych-w-kielcach" target = "_blank">Dni pełne inspiracji i europejskiej współpracy – Erasmus Days 2025 w Zespole Szkół Informatycznych w Kielcach</a></li>
                <li><a href = "https://www.kielce.eu/pl/aktualnosci/dni-erasmusa-w-zespole-szkol-informatycznych-w-kielcach.html" target = "_blank">Dni Erasmusa w Zespole Szkół Informatycznych w Kielcach</a></li>
            </ul>

            <br />

            <h2><strong>Instytucja partnerska EuroMind</strong></h2>
            <ul>
                <li><a href = "https://www.euromind.es/" target = "_blank">Strona internetowa</a></li>
                <li><a href = "https://www.facebook.com/euromind.spain" target = "_blank">Facebook</a></li>
                <li><a href = "https://www.instagram.com/euromind.spain/?hl=pl" target = "_blank">Instagram</a></li>
                
            </ul>

             <br />

            <h2><strong>O stażu w EuroMind</strong></h2>
            <ul>
                <li><a href = "https://www.facebook.com/euromind.spain/posts/pfbid0QiXweht4D3gmiGWy7u8KMoZTr8f8TCdK4Q6pGZCuCtX9kqPEewdxdhoQXZb5k52Al?rdid=AV4ECG2dwyZSfbDS#" target = "_blank">Facebook</a></li>
                
            </ul>

            <br />

            <h2><strong>Filmy instruktażowe</strong></h2>
            <ul>
                <li><a href = "https://www.youtube.com/watch?v=3xLfDd6e0wg" target = "_blank">Jak przygotować środowisko programistyczne wykorzystywane przy tworzeniu platformy e-commerce</a></li>
                <li><a href = "https://www.youtube.com/watch?v=o3P6XSuUsKE" target = "_blank">Pierwsze kroki w tworzeniu gier VR w Unity</a></li>
                
            </ul>

            <br />

        </div>
    )
}

export default Links;